import api from 'api';
import storage from "@/cflow/storageService";

class userService {

    login(email,senha) {
        return new Promise((resolve, reject) => {
            //const token = JSON.parse(localStorage.getItem('token'));
            api.post('/login', {email: email,senha: senha ? senha : ''}).then((result) => {

                // se erro login, valida.
                if(result?.response?.status == 406) {
                    reject(result);
                } else {
                    if(!result.data.avatar) result.data.avatar = 'img/no-image/user.png';
                    resolve(result.data);
                }
                
            }).catch((error) => {
                reject(error);
            });
        });
    }

    logoff(){
        storage.clear('user');
    }

    doTokenEmail(email) {
        return new Promise((resolve, reject) => {
            //const token = JSON.parse(localStorage.getItem('token'));
            api.post('/recovery1', {email: email}).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    waitTokenEmail(recovery_code) {
        return new Promise((resolve, reject) => {
            //const token = JSON.parse(localStorage.getItem('token'));
            api.post('/recovery2', {recovery_code: recovery_code}).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    updatePassword(recovery_code, password) {
        return new Promise((resolve, reject) => {
            //const token = JSON.parse(localStorage.getItem('token'));
            api.post('/recovery3', {recovery_code: recovery_code, password: password}).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    changePassword(id, password, password2) {
        return new Promise((resolve, reject) => {
            //const token = JSON.parse(localStorage.getItem('token'));
            api.post('/changepass', {id: id, password: password, password2: password2}).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    checkLogin(){
        var token = storage.get("user","token")
        if(token){
            return new Promise((resolve, reject) => {
                //const token = JSON.parse(localStorage.getItem('token'));
                api.post('/login', {token: token}).then((result) => {
                    // Se não tiver foto de perfil, colocar uma padrão:
                if(!result.data.avatar) result.data.avatar = 'img/no-image/user.png';
                    resolve(result.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    }

    registroLaboratorio(dados){
        return new Promise((resolve, reject) => {
            api.post('/laboratorio/registro', dados).then((result) => {
                if(!result.data.avatar) result.data.avatar = 'img/no-image/user.png';
                resolve(result.data);
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    registroDentista(dados){
        return new Promise((resolve, reject) => {
            api.post('/dentista/registro', dados).then((result) => {
                if(!result.data.avatar) result.data.avatar = 'img/no-image/user.png';
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    isLogged(){
        var token = storage.get("user","token")
        if(token){
            return new Promise((resolve, reject) => {
                //const token = JSON.parse(localStorage.getItem('token'));
                const user = storage.get('user');
                api.get('/status/isLogged?token='+user.token).then((result) => {
                    resolve(result.data);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    }

    cancelar(dados){
        return new Promise((resolve, reject) => {
            api.post('/configuracoes/cancelar', dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new userService();